import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { TitleDivider } from '@stack/ui/components';

import { Props } from './props';

const CarFaq: React.FC<Props> = (props) => {
  const { data } = props;

  const renderContent = (title: string, content: string, index: number) => {
    return (
      <Accordion
        key={`faq-${index}`}
        square
        disableGutters
        sx={{
          ':last-of-type': {
            borderRadius: 0,
          },
          border: 'none !important',
          borderBottom: '1px solid #EDECED !important',
          bgcolor: 'transparent',
        }}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowDownIcon sx={{ color: 'text.primary' }} />}
          sx={{
            fontSize: 16,
            fontWeight: 700,
            border: 'none',
            py: 5,
            px: 0,
            pt: index === 0 ? 0 : 5,
            '& .MuiAccordionSummary-content': {
              margin: 0,
            },
          }}
        >
          {title}
        </AccordionSummary>
        <AccordionDetails sx={{ fontSize: 14, px: 0 }}>
          {content}
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <TitleDivider title={'FAQ'}>
      {data?.map((e, index) => renderContent(e.title, e.answer, index))}
    </TitleDivider>
  );
};

export default CarFaq;
